import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from '@mafc/trolly';

import { isExpressShipment } from 'pages/NewCart/helpers/shipment.helper';
import * as S from './ShipmentCardFooter.style';
import { getFormattedPrice } from 'utils/price.util';
import MinimumOrderNotification from '../MinimumOrderNotification';
import { INewCartShipment } from 'pages/NewCart/ICart';
import { minimumMovMetShipmentLevel } from '../MinimumOrderNotification/MinimumOrderNotification.utils';

const ShipmentCardFooter: React.FC<{
  shipment: INewCartShipment;
  checkoutHandler: React.MouseEventHandler<HTMLButtonElement>;
  disableCheckout: boolean;
}> = ({ shipment, checkoutHandler, disableCheckout = false }) => {
  const { t } = useTranslation();

  const isExpress = isExpressShipment(shipment.shipmentType);

  const { showNotification, message, thresholdPercentage } = useMemo(() => {
    return minimumMovMetShipmentLevel(shipment, t);
  }, [shipment, t]);

  return (
    <S.ShipmentCardFooter>
      <MinimumOrderNotification
        showNotification={showNotification}
        message={message}
        withColor
        thresholdPercentage={thresholdPercentage}
      />

      <Flex justifyContent="space-between">
        <Box>
          <S.ShipmentSubTotalLabel>{t('cartShipment.subTotal')}</S.ShipmentSubTotalLabel>
          <S.ShipmentSubTotal>
            {getFormattedPrice(shipment.subTotal, false, true, true)}
          </S.ShipmentSubTotal>
        </Box>

        <S.CheckoutButton
          onClick={checkoutHandler}
          disabledNew={disableCheckout || showNotification}
          variant="secondary"
          size="CUSTOM"
        >
          <>{isExpress ? t('cartShipment.checkoutNow') : t('cartShipment.checkout')}</>
        </S.CheckoutButton>
      </Flex>
    </S.ShipmentCardFooter>
  );
};

export default ShipmentCardFooter;
